import styled from 'styled-components';

import mediaQueries from 'constants/mediaQueries';
import { colorBrandPrimary400 } from 'constants/colors';

export const Holder = styled.div<{ backgroundColor?: string }>`
  color: ${colorBrandPrimary400};
  ${({ backgroundColor }) =>
    (backgroundColor && `background: ${backgroundColor}`) || ''};
`;

export const Hamburger = styled.div`
  z-index: 1;
  height: 24px;
`;

export const MobileHeader = styled.div`
  height: 24px;
  ${mediaQueries.desktop} {
    display: none;
  }
`;

export const DesktopHeader = styled.div`
  z-index: 10000;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-grow: 1;

  ${mediaQueries.tabletAndMobileOnly} {
    display: none;
  }
`;

export const RightSideItem = styled.div`
  font-size: 14px;
  line-height: 19px;
  text-align: right;
  display: flex;
  align-items: center;
  margin-left: 40px;
`;

export const BackButton = styled.a`
  font-size: 14px;
  color: inherit;
  text-decoration: none;
  white-space: nowrap;
`;
